/** A page requests a call; the persistent Phone panel owns confirmation and dialing. */
export type VicidialCallIntent = {
  requestId: number | string
  requestLabel: string
  contactName: string
  contactNumber: string
  placement?: 'left' | 'right'
}

export const VICIDIAL_CALL_INTENT_EVENT = 'atlas-vicidial-call-intent'

export function openVicidialCall(intent: VicidialCallIntent): void {
  window.dispatchEvent(new CustomEvent<VicidialCallIntent>(VICIDIAL_CALL_INTENT_EVENT, { detail: intent }))
}
